import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  Stack,
  Paper,
} from '@mui/material';
import html2canvas from 'html2canvas';
import './TemplateRenderer.css'; // Contains custom CSS for rendering

function TemplateRenderer() {
  const [inputs, setInputs] = useState({
    img_ap_templating: '',
    info_cup: '',
    info_stem: '',
    info_head: '',
    info_osteotomy: '',
    info_lld: '',
    info_remarks: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs({ ...inputs, [name]: value });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setInputs({ ...inputs, img_ap_templating: reader.result });
      reader.readAsDataURL(file);
    }
  };

  const exportAsImage = async () => {
    const element = document.getElementById('render-area');
    const canvas = await html2canvas(element, { scale: 2 }); // No scaling required
    const dataUrl = canvas.toDataURL('image/png');

    // Create a download link
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = 'rendered-template.png';
    link.click();
  };

  return (
    <Box
        sx={{
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
        }}
        >
        <Typography variant="h4" align="center" gutterBottom>
            Navbit Template Report Builder
        </Typography>

        {/* Input Section */}
        <Paper
            elevation={3}
            sx={{
            padding: '20px',
            marginBottom: '20px',
            width: '820px',
            }}
        >

        <Stack spacing={2}>
            <Button variant="contained" component="label">
                Upload Image
                <input type="file" accept="image/*" hidden onChange={handleImageUpload} />
            </Button>

            {/* Two Columns of Inputs */}
            <Stack direction="row" spacing={2}>
                {/* Left Column */}
                <Stack spacing={2} flex={1}>
                <TextField
                    fullWidth
                    label="Cup"
                    name="info_cup"
                    value={inputs.info_cup}
                    onChange={handleInputChange}
                />
                <TextField
                    fullWidth
                    label="Head"
                    name="info_head"
                    value={inputs.info_head}
                    onChange={handleInputChange}
                />
                <TextField
                    fullWidth
                    label="Leg Length Discrepancy"
                    name="info_lld"
                    value={inputs.info_lld}
                    onChange={handleInputChange}
                />
                </Stack>

                {/* Right Column */}
                <Stack spacing={2} flex={1}>
                <TextField
                    fullWidth
                    label="Stem"
                    name="info_stem"
                    value={inputs.info_stem}
                    onChange={handleInputChange}
                />
                <TextField
                    fullWidth
                    label="Osteotomy"
                    name="info_osteotomy"
                    value={inputs.info_osteotomy}
                    onChange={handleInputChange}
                />
                <TextField
                    fullWidth
                    label="Remarks"
                    name="info_remarks"
                    value={inputs.info_remarks}
                    onChange={handleInputChange}
                />
                </Stack>
            </Stack>
            </Stack>
        </Paper>

      {/* Template Rendering */}
      <div id="render-area" className="render-container">
        <div className="flex-parent">
          {/* Image Section */}
          <div className="image_container">
            {inputs.img_ap_templating && (
              <img
                src={inputs.img_ap_templating}
                alt="AP Templating"
              />
            )}
          </div>

          {/* Information Section */}
          <div style={{ flexGrow: "1", width:"266px", paddingRight: '10px', paddingLeft: '25px' }}>
            <div className="divider" id="divider-1"></div>
            <div className="templatinginfo1">
              Cup<br />
              <span className="templatinginfo2">{inputs.info_cup}</span>
            </div>
            <div className="templatinginfo1">
              Stem<br />
              <span className="templatinginfo2">{inputs.info_stem}</span>
            </div>
            <div className="templatinginfo1">
              Head<br />
              <span className="templatinginfo2">{inputs.info_head}</span>
            </div>
            <div className="templatinginfo1">
              Osteotomy<br />
              <span className="templatinginfo2">{inputs.info_osteotomy}</span>
            </div>
            <div className="templatinginfo1">
              Leg Length Discrepancy<br />
              <span className="templatinginfo2">{inputs.info_lld}</span>
            </div>
            <div className="divider" id="divider-2"></div>
            <div className="remarks-title">Remarks:</div>
            <div className="remarks">{inputs.info_remarks}</div>
          </div>
        </div>
      </div>

      {/* Export Button */}
      <Box sx={{ textAlign: 'center' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={exportAsImage}
          sx={{ marginTop: '20px' }}
        >
          Export as Image
        </Button>
      </Box>
    </Box>
  );
}

export default TemplateRenderer;
